import classnames from 'classnames';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { PropsWithChildren } from 'react';

import styles from './teamCard.module.scss';

type ContentProps = PropsWithChildren<PropsWithClassName>;

export const Content = ({ children, className }: ContentProps): JSX.Element => (
  <ul className={classnames(styles.contentTeam, className)}>{children}</ul>
);

Content.displayName = 'Content';
